import { isEqual } from 'lodash';
import isEmpty from 'lodash/isEmpty';

import { NewsAndEventsModel } from '../../../interface/news-and-events';
import NewsCard from '../../molecules/news-card/news-card';

/* eslint-disable-next-line */
type FilteredNewsCardsProps =  {
  currentContent: NewsAndEventsModel[];
  filteredNewsAndEventsContent: NewsAndEventsModel[];
  selectedYear: string;
};

export function FilteredNewsCards(props: FilteredNewsCardsProps) {
  const { currentContent, filteredNewsAndEventsContent, selectedYear } = props;

  const newsCards = currentContent.map((newsItem) => {
    return (
      <NewsCard
        ctaLink={newsItem.attributes.slug}
        description={newsItem.attributes.news_excerpt}
        key={newsItem.attributes.slug}
        src={newsItem.attributes.news_image.data.attributes.url}
        title={newsItem.attributes.news_title}
      />
    );
  });

  const filteredNewsCards = !isEmpty(selectedYear)
    ? filteredNewsAndEventsContent
        .filter((newsItem) =>
          isEqual(newsItem.attributes.year_posted, selectedYear)
        )
        .map((newsItem) => {
          return (
            <NewsCard
              ctaLink={newsItem.attributes.slug}
              description={newsItem.attributes.news_excerpt}
              key={newsItem.attributes.slug}
              src={newsItem.attributes.news_image.data.attributes.url}
              title={newsItem.attributes.news_title}
            />
          );
        })
    : newsCards;

  return <>{filteredNewsCards}</>;
}

export default FilteredNewsCards;
